import api from '../services/api';
import {
  ILinkedTreatmentProduct,
  IRetailTreatmentItem,
  ITreatment,
  ITreatmentItem,
} from '../shared/interfaces';

interface IResponseGetTreatments {
  data: ITreatment[];
  count: number;
}

export const getTreatments = async (
  client_id: string | undefined,
  take: number,
  skip: number,
  keyword?: string,
  type?: number | null,
): Promise<IResponseGetTreatments> => {
  const response = await api.post('/treatments/list', {
    client_id,
    take,
    skip,
    keyword,
    type,
  });
  return response.data;
};

interface IResponseGetTreatment {
  treatment: ITreatment;
  items: ITreatmentItem[];
  linked_products?: ILinkedTreatmentProduct[];
  retail_items?: IRetailTreatmentItem[];
}

export const getTreatment = async (
  id: string | undefined,
): Promise<IResponseGetTreatment> => {
  if (!id) {
    throw new Error('ID do tratamento não fornecido.');
  }
  const response = await api.get(`/treatments/${id}`);
  return response.data;
};

export const postTreatment = async (payload: any): Promise<ITreatment> => {
  const response = await api.post('/treatments', payload);
  return response.data;
};

export const patchTreatment = async (
  id: string | undefined,
  payload: any,
): Promise<ITreatment> => {
  if (!id) {
    throw new Error('ID do tratamento não fornecido.');
  }
  const response = await api.patch(`/treatments/${id}`, payload);
  return response.data;
};
